import L from 'lodash'

// @ts-ignore Cannot find module
import { CUSTOM_EVENT_KEY_CODE } from '@straal/assets/staticViews/scripts/consts'

type InputEvent = {
  which: number
}

export const addClass = function(
  element: HTMLElement,
  classToAdd: string,
): void {
  element.classList.add(classToAdd)
}

export const removeClass = function(
  element: HTMLElement,
  classToRemove: string,
): void {
  element.classList.remove(classToRemove)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUrlParam = function(param: any): any {
  const urlString = L.get(window, 'location.href')
  const url = new URL(urlString)

  return url.searchParams.get(param)
}

export const redirect = function(page: string): void {
  const newLocation = `${window.location.origin}/${page}`

  L.set(window, 'location', newLocation)
}

export const blurEvent = function(callback: fn, event: InputEvent): void {
  const keyCodes = L.concat(
    [
      CUSTOM_EVENT_KEY_CODE, // manual trigger
      8, // backspace
      13, // return
      32, // spacebar
      46, // delete
    ],
    L.range(48, 91), // alphanumeric
    L.range(96, 112), // numpad
    L.range(186, 193), // ;=,-./`
    L.range(219, 223), // [\]'
  )
  const { which: keyCode } = event

  if (L.includes(keyCodes, keyCode)) callback(event)
}

export const returnKeyEvent = function(callback: fn, event: InputEvent): void {
  const returnKeyCode = 13
  const { which: keyCode } = event

  if (L.isEqual(keyCode, returnKeyCode)) callback(event)
}
